import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {DICTIONARY} from '../../../../dictionary';
import {RouteService} from '../../../../services/routeService';
import {GeneralService} from '../../../../services/generalService';
import {NotificationService} from '../../../../services/notificationService';
import {buildInboundFlow, buildOutboundFlow, EmailFlowResult} from './email-flow-specs';

@Component({
	selector: 'email-flow-view-component',
	templateUrl: './email-flow-view.component.html',
	styleUrls: ['./email-flow-view.component.scss'],
})
export class EmailFlowViewComponent implements OnInit, OnDestroy {
	dic = DICTIONARY;
	direction: 'inbound' | 'outbound' = 'inbound';
	loading = true;
	loadError = false;
	flow: EmailFlowResult = null;
	brand = 'Trustifi';
	powershellManaged = false;

	private dataSub: Subscription;

	constructor(private route: ActivatedRoute,
				private router: Router,
				private rs: RouteService,
				public gs: GeneralService,
				private ns: NotificationService) {
	}

	ngOnInit() {
		this.brand = this.gs.corpname || 'Trustifi';
		this.dataSub = this.route.data.subscribe(data => {
			this.direction = data.direction || 'inbound';
			this.loadFlow();
		});
	}

	ngOnDestroy() {
		if (this.dataSub) {
			this.dataSub.unsubscribe();
		}
	}

	loadFlow = () => {
		this.loading = true;
		this.loadError = false;
		this.flow = null;
		const request = this.direction === 'inbound' ? this.rs.getInboundPlanSettings() : this.rs.getOutboundPlanSettings();
		request.then((planInfo) => {
			this.flow = this.direction === 'inbound' ?
				buildInboundFlow(planInfo, this.brand) :
				buildOutboundFlow(planInfo, this.brand);
			this.powershellManaged = !!planInfo.powershell?.enabled && this.flow.platform === 'm365';
			this.loading = false;
		}, (err) => {
			this.loading = false;
			this.loadError = true;
			if (err?.data?.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
		});
	}

	goToSetup = () => {
		if (this.direction === 'inbound') {
			this.router.navigate([this.dic.CONSTANTS.appStates.adminInbound,
				this.dic.CONSTANTS.adminPages.inbound.plan,
				this.dic.CONSTANTS.inboundPlanSettingsPageTabs.emailFlowIntegration]);
		}
		else {
			this.router.navigate([this.dic.CONSTANTS.appStates.adminOutbound,
				this.dic.CONSTANTS.adminPages.outbound.sharedPlan,
				this.dic.CONSTANTS.outboundPlanSettingsPageTabs.emailFlowIntegration]);
		}
	}
}
